/**
 * Pixel sizes of images the app has already loaded, per URL. An image whose
 * content records no size (an external URL, an agent's image) still gets its
 * aspect once its card has shown it: the card's `<img>` reports its natural
 * size here, and `firstCardImage` reads it after the stored size.
 */

export interface ImagePixelSize {
  width: number;
  height: number;
}

/** Enough for every card on a wall; the oldest entry goes first. */
const MAX_KNOWN_IMAGES = 1000;

const knownSizes = new Map<string, ImagePixelSize>();

export function rememberImageSize(
  url: string,
  width: number,
  height: number,
): void {
  if (!url || !(width > 0) || !(height > 0)) return;
  knownSizes.delete(url);
  knownSizes.set(url, { width, height });
  if (knownSizes.size > MAX_KNOWN_IMAGES) {
    const oldest = knownSizes.keys().next().value;
    if (oldest !== undefined) knownSizes.delete(oldest);
  }
}

export function knownImageSize(url: string): ImagePixelSize | null {
  return (url && knownSizes.get(url)) || null;
}
